// Form validation for New credential form
import { plaintextValidator, dropdownValidator } from '../fields';

const config = { mandatory: true, customError: `^ Required` };
const dropdownConfig = { mandatory: true, customError: `Required` };

export default {
  // clientId: dropdownValidator(dropdownConfig), comment for IT product
  name: plaintextValidator(config),
  protocol: plaintextValidator(config)
};
